import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required, numeric } from 'vuelidate/lib/validators';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import { Getter } from 'vuex-class';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import BaseDateTimeField from '@/components/datetime_field/Index.vue';
import DateMixin from '@/helpers/mixins/DateMixin';
import WhiteSpaceCheckerMixin from '@/helpers/vue_mixins/WhiteSpaceCheckerMixin';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import BaseTimePicker from '@/components/timepicker/Index.vue';
import moment from 'moment';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let PromoCodeForm = class PromoCodeForm extends mixins(FormMixin, DateMixin, ViewportSizeMixin, WhiteSpaceCheckerMixin) {
    constructor() {
        super(...arguments);
        this.date = null;
        this.form = {
            code: null,
            value: null,
            startAt: moment().format('YYYY-MM-DD'),
            endAt: null,
            usageLimit: null,
            startAtTime: moment().format('HH:mm'),
            endAtTime: null,
            active: true,
            paymentOptions: null,
            valueType: null,
            minimumSpend: 0.0,
            applicablePaymentOption: 'to_all',
            firstTime: false,
            voucherVisibility: 'private_posts',
            promotionSetting: null,
            stackable: false,
        };
        this.openStartDateModal = false;
        this.openEndDateModal = false;
        this.openStartTimeModal = false;
        this.openEndTimeModal = false;
    }
    get action() {
        return this.update ? 'Edit' : 'Create';
    }
    get valueTypes() {
        return [
            selectOptionBuilder('absolute', 'Absolute'),
            selectOptionBuilder('percentage', 'Percentage'),
        ];
    }
    get isPublic() {
        return this.form.voucherVisibility === 'public_posts';
    }
    get paymentOptionTypes() {
        return [
            selectOptionBuilder('to_all', 'All'),
            selectOptionBuilder('cod', 'Cash On Delivery'),
            selectOptionBuilder('bank', 'Bank Deposit'),
            selectOptionBuilder('bpi', 'BPI'),
            selectOptionBuilder('gcash', 'GCash'),
            selectOptionBuilder('credit_card', 'Card Payments (Mastercard, VISA, JCB)'),
        ];
    }
    get discountTypeIsPercentage() {
        return this.$v.form.valueType.$model === 'percentage';
    }
    resetDiscountValue() {
        this.$v.form.value.$model = null;
    }
    get minEndAtDate() {
        const startDate = new Date(this.form.startAt);
        const minDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 2);
        return moment(minDate).format('YYYY-MM-DD');
    }
    get codeErrors() {
        const errors = [];
        if (!this.$v.form.code.hasWhiteSpace) {
            const errorMsg = this.whiteSpaceErrorMsgBuilder('code');
            errors.push(errorMsg);
        }
        if (!this.$v.form.code.$dirty) {
            return errors;
        }
        if (!this.$v.form.code.required) {
            const msg = requiredProperty('Code');
            errors.push(msg);
        }
        return errors;
    }
    get valueErrors() {
        const errors = [];
        if (!this.$v.form.value.$dirty) {
            return errors;
        }
        if (!this.$v.form.value.required) {
            const msg = requiredProperty('Value');
            errors.push(msg);
        }
        return errors;
    }
    get valueTypeErrors() {
        const errors = [];
        if (!this.$v.form.valueType.$dirty) {
            return errors;
        }
        if (!this.$v.form.valueType.required) {
            const msg = requiredProperty('Discount Type');
            errors.push(msg);
        }
        return errors;
    }
    get paymentOptionErrors() {
        const errors = [];
        if (!this.$v.form.applicablePaymentOption.$dirty) {
            return errors;
        }
        if (!this.$v.form.applicablePaymentOption.required) {
            const msg = requiredProperty('Payment Option');
            errors.push(msg);
        }
        return errors;
    }
    get minimumSpendErrors() {
        const errors = [];
        if (!this.$v.form.minimumSpend.$dirty) {
            return errors;
        }
        if (!this.$v.form.minimumSpend.required) {
            const msg = requiredProperty('Discount Type');
            errors.push(msg);
        }
        return errors;
    }
    get usageLimitErrors() {
        const errors = [];
        if (!this.$v.form.usageLimit.$dirty) {
            return errors;
        }
        if (!this.$v.form.usageLimit.required) {
            const msg = requiredProperty('Usage Limit');
            errors.push(msg);
        }
        return errors;
    }
    get endAtErrors() {
        const errors = [];
        if (!this.$v.form.endAt.$dirty) {
            return errors;
        }
        if (!this.$v.form.endAt.required) {
            const msg = requiredProperty('End Date');
            errors.push(msg);
        }
        if (!this.$v.form.endAt.mustBeAfterStartDate) {
            errors.push('End Date should be after Start Date');
        }
        return errors;
    }
    get endTimeErrors() {
        const errors = [];
        if (!this.$v.form.endAtTime.$dirty) {
            return errors;
        }
        if (!this.$v.form.endAtTime.required) {
            const msg = requiredProperty('End Time');
            errors.push(msg);
        }
        return errors;
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            if (this.form.voucherVisibility === 'private_posts') {
                this.form.promotionSetting = null;
            }
            this.$emit('submit', this.form);
        }
    }
    mounted() {
        if (this.formData) {
            this.form = { ...this.formData };
        }
        if (typeof this.form.promotionSetting === 'string') {
            this.form.promotionSetting = JSON.parse(this.form.promotionSetting);
        }
    }
    onVoucherVisibilityChange(value, oldValue) {
        if (value === 'private_posts') {
            if (!this.form.promotionSetting || this.form.promotionSetting.length === 0) {
                this.form.promotionSetting = [];
            }
        }
        else if (!this.form.promotionSetting || this.form.promotionSetting.length === 0) {
            this.form.promotionSetting = [
                'all_channel',
                'public_post',
                'public_comment',
                'direct_message',
            ];
        }
        else if (this.form.promotionSetting.length === 1 && this.form.promotionSetting[0] === null) {
            this.form.promotionSetting = [
                'all_channel',
                'public_post',
                'public_comment',
                'direct_message',
            ];
        }
        this.adjustPromotionSetting();
    }
    onPromotionSettingChange(newVal) {
        this.adjustPromotionSetting();
    }
    adjustPromotionSetting() {
        if (this.form.promotionSetting) {
            const allOptionsChecked = this.form.promotionSetting.includes('public_post') &&
                this.form.promotionSetting.includes('public_comment') &&
                this.form.promotionSetting.includes('direct_message');
            if (!this.form.promotionSetting.includes('all_channel') && allOptionsChecked) {
                this.form.promotionSetting = [
                    'all_channel',
                    'public_post',
                    'public_comment',
                    'direct_message',
                ];
            }
        }
    }
    handlePromotionSettingChange(value) {
        if (value === 'all_channel') {
            if (this.form.promotionSetting && this.form.promotionSetting.length > 0) {
                const allChecked = this.form.promotionSetting.includes('public_post') &&
                    this.form.promotionSetting.includes('public_comment') &&
                    this.form.promotionSetting.includes('direct_message');
                if (allChecked) {
                    this.form.promotionSetting = [];
                }
                else {
                    this.form.promotionSetting = [
                        'all_channel',
                        'public_post',
                        'public_comment',
                        'direct_message',
                    ];
                }
            }
            else {
                this.form.promotionSetting = ['all_channel'];
            }
        }
        else if (this.form.promotionSetting) {
            const index = this.form.promotionSetting.indexOf('all_channel');
            if (index !== -1) {
                this.form.promotionSetting.splice(index, 1);
            }
        }
    }
    handleVisibilityChange(selectedValue) {
        this.form.voucherVisibility = selectedValue;
    }
};
__decorate([
    Getter('requestOnFlight')
], PromoCodeForm.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PromoCodeForm.prototype, "update", void 0);
__decorate([
    Prop({ type: Object, default: null })
], PromoCodeForm.prototype, "formData", void 0);
__decorate([
    Watch('form.voucherVisibility')
], PromoCodeForm.prototype, "onVoucherVisibilityChange", null);
__decorate([
    Watch('form.promotionSetting')
], PromoCodeForm.prototype, "onPromotionSettingChange", null);
PromoCodeForm = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
            NumericInput,
            BaseTextField,
            BaseDateTimeField,
            BaseDatePicker,
            BaseTimePicker,
        },
        validations: {
            form: {
                code: {
                    required,
                    hasWhiteSpace() {
                        const vm = this;
                        const { code } = this.form;
                        if (code === null || code === undefined) {
                            return true; // Consider having whitespace if value is null or undefined
                        }
                        return !vm.trailingWhitespace(code);
                    },
                },
                value: {
                    numeric,
                    required,
                },
                usageLimit: {
                    numeric,
                    required,
                },
                minimumSpend: {
                    numeric,
                    required,
                },
                valueType: {
                    required,
                },
                startAt: {
                    required,
                },
                endAt: {
                    required,
                    mustBeAfterStartDate() {
                        const startDate = this.form.startAt;
                        const endDate = this.form.endAt;
                        const parsedStartDate = new Date(startDate);
                        const parsedEndDate = new Date(endDate);
                        return parsedEndDate > parsedStartDate;
                    },
                },
                startAtTime: {
                    required,
                },
                endAtTime: {
                    required,
                },
                applicablePaymentOption: {
                    required,
                },
                firstTime: {
                    required,
                },
                voucherVisibility: {
                    required,
                },
                promotionSetting: {},
                stackable: {
                    required,
                },
            },
        },
    })
], PromoCodeForm);
export default PromoCodeForm;
